/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.transportation.bus-routes'},
});

const BusRoutesItem = () => (
  <RouteLinkItem
    route="midas/settings/transportation/bus-routes"
    title={messages.title}
  />
);

export default BusRoutesItem;
